import React from "react";
import ReactDOM from "react-dom";
import sampleData from './data-female-science-swarm'
import { ResponsiveSwarmPlot } from '@nivo/swarmplot'

const format = v => `${v}%`

const App = () => (
  <div className="App" style={{height: 500, fontFamily: 'sans-serif'}}>
    <ResponsiveSwarmPlot
        data={sampleData}
        groups={[ 'First Author', 'Last Author', 'Single Author' ]}
        identity="id"
        colors={{ scheme: 'spectral' }}
        value="percentage"
        colorBy="id"
        valueFormat={format}
        valueScale={{ type: 'linear', min: 0, max: 100, reverse: false }}
        size={{
            key: 'volume',
            values: [
                1000,
                882348
            ],
            sizes: [
                5,
                50
            ]
        }}
        forceStrength={4}
        simulationIterations={100}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.6
                ],
                [
                    'opacity',
                    0.5
                ]
            ]
        }}
        margin={{ top: 30, right: 100, bottom: 80, left: 100 }}
        axisTop={{
            orient: 'top',
            tickSize: 10,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: -46
        }}
        axisRight={{
            orient: 'right',
            tickSize: 10,
            tickValues: [0, 25, 50, 100],
            tickPadding: 5,
            tickRotation: 0,
            legend: 'percentage of woman',
            legendPosition: 'middle',
            legendOffset: 76
        }}
        axisBottom={{
            orient: 'bottom',
            tickSize: 10,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 46
        }}
        axisLeft={{
            orient: 'left',
            tickSize: 10,
            tickValues: [0, 25, 50, 100],
            tickPadding: 5,
            tickRotation: 0,
            legend: 'percentage of woman',
            legendPosition: 'middle',
            legendOffset: -76
        }}
    />
  </div>
);

ReactDOM.render(<App />, document.getElementById("root"));